var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21",
        height: "22",
        viewBox: "0 0 21 22",
        fill: "black",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M5.59223 5.51193L5.60337 5.52307L5.61458 5.512C8.386 2.77538 12.85 2.78489 15.6056 5.54363L15.6056 5.54364C18.3738 8.31188 18.3738 12.798 15.6056 15.5663C12.8373 18.3345 8.35119 18.3345 5.58295 15.5663C5.19279 15.1761 5.19279 14.5425 5.58295 14.1523C5.9731 13.7622 6.60674 13.7622 6.99689 14.1523C8.98483 16.1403 12.2069 16.1403 14.1948 14.1523C16.1827 12.1644 16.1827 8.94234 14.1948 6.95441C12.2164 4.97602 9.01981 4.96648 7.0287 6.9226L7.0173 6.9338L7.02859 6.94511L8.33178 8.25147L8.33179 8.25149C8.546 8.4657 8.60814 8.78547 8.49322 9.065C8.37838 9.34433 8.10521 9.52445 7.80397 9.52445H4.01488H3.74536C3.33241 9.52445 3.00023 9.19227 3.00023 8.77931V4.7207C3.00023 4.41947 3.18034 4.14629 3.45968 4.03145C3.7392 3.91654 4.05898 3.97867 4.27319 4.19288L5.59223 5.51193Z",
          fill: "black",
          stroke: "black",
          "stroke-width": "0.0317079",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }